function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgDekoBottom = function SvgDekoBottom(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 429.5 217.75"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M429.5 27.91v189.84H0V34.74c11.08-3.35 21.96-8.34 31.99-13.16C42.34 16.61 53.04 11.47 64.8 7.92 82.67 2.53 95.27.02 104.46.02c3.97-.14 7.92.55 11.6 2.03 2.94 1.25 5.39 3.44 6.96 6.22 2.96 5.15 1.06 12.36-1.35 21.48-1.86 7.04-3.96 15.01-4.51 24.22-.27 3.57.13 7.17 1.18 10.59.95 2.96 2.55 5.66 4.68 7.92 3.36 3.57 8.22 6.26 14.45 7.98a79.807 79.807 0 0 0 20.93 2.4c15 0 34.02-2.7 56.53-8.03 17.38-4.11 36.38-9.66 56.49-16.49 2.28-.77 4.58-1.56 7.03-2.4l.21-.07c36.79-12.57 87.16-29.78 129.04-29.78 7.3-.05 14.6.57 21.79 1.83",
    style: {
      fill: "#b4c897"
    }
  }));
};
export default SvgDekoBottom;